import React from 'react'
import * as ReactDOMClient from 'react-dom/client'
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
} from "@apollo/client";

// import './index.css'
// import EcsMain from './EcsMain'
import AppRouter from './AppRouter'

const apolloClient = new ApolloClient({
  uri: 'https://api-us-west-2.graphcms.com/v2/cl4k7xj7x5jgb01xof6l8609l/master',
  cache: new InMemoryCache()
});

const root = ReactDOMClient.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <AppRouter />
    </ApolloProvider>
  </React.StrictMode>
)

